import release from "./release.json";

function ReleaseNote() {
  return (
    <div className="prose max-w-none p-4">
      <h1 className="font-bold">Release Notes</h1>
      <h3 className="font-semibold ">Project: {release.title}</h3>
      <h4 className="underline">Credentials</h4>
      <ul>
        <li>
          <a href={release.live} className="no-underline">
            Live link
          </a>
        </li>
        <li>
          <a href={release.github} className="no-underline">
            Github
          </a>
        </li>
      </ul>
      <article>
        <h4 className="mb-0 mt-10 underline">Features</h4>
        <div className="border-0">
          <ol className="grid grid-cols-3 my-0 py-0">
            {release.features.map((feature, index) => (
              <li key={index} className="capitalize">
                <p>{feature}</p>
              </li>
            ))}
          </ol>
        </div>
      </article>
    </div>
  );
}

export default ReleaseNote;
